module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[70]69.5c0ad43.woff2";